import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import Content from './Content'
import Footer from './Footer'

interface Props {
  compensationsCount: number
  onCloseModal: () => void
  onConfirm: () => void
}

const DeletePolicyModal = ({ compensationsCount, onCloseModal, onConfirm }: Props) => {
  const onSubmit = () => {
    onConfirm()
  }
  return (
    <Modal
      title={i18n.t('contract_versions.flows.update.steps.role_level_salary.policy.delete_title')}
      illustration="alert"
      onSubmit={onSubmit}
      onClose={onCloseModal}
      description={<Content compensationsCount={compensationsCount} />}
      footer={<Footer onCloseModal={onCloseModal} />}
    />
  )
}

export default observer(DeletePolicyModal)
